import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import LoginPage from "./pages/auth/LoginPage";
import ListPage from "./pages/customers/ListPage";
import CustomerDetails from "./pages/customerDetails/CustomerDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import EmployerList from "./pages/employers/EmployerList";
import EmployeeList from "./pages/employees/EmployeeList";
import UpdatePassword from "./pages/auth/UpdatePassword";
import TrayHistory from "./pages/trays/trayHistory";
import BranchesList from "./pages/branches/BranchesList";
import StockList from "./pages/stock/StockList";
import Dashboard from "./pages/dashboard/Dashboard";
import ReceiptViewer from "./pages/ReceiptViewer";
import TransactionViewer from "./pages/TransactionViewer";
import UsersList from "./pages/users/UsersList";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route path="/" element={<Navigate to="/list" replace />} />

      <Route
        path="/users"
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <UsersList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/list"
        element={
          <ProtectedRoute>
            <ListPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/branches"
        element={
          <ProtectedRoute>
            <BranchesList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/stock"
        element={
          <ProtectedRoute>
            <StockList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/password-update"
        element={
          <ProtectedRoute>
            <UpdatePassword />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customer-details/:id"
        element={
          <ProtectedRoute>
            <CustomerDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/tray-history/:id"
        element={
          <ProtectedRoute>
            <TrayHistory />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employers"
        element={
          <ProtectedRoute>
            <EmployerList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employees"
        element={
          <ProtectedRoute>
            <EmployeeList />
          </ProtectedRoute>
        }
      />

      <Route path="/receipt/:transactionId" element={<ReceiptViewer />} />

      <Route path="/transactions/anonomous" element={<TransactionViewer />} />

    </Routes>
  );
}

